import techcrunch from "@/assets/images/techcrunch.png";
import google from "@/assets/images/google.png";
import substack from "@/assets/images/substack.png";
import nvidia from "@/assets/images/nvidia.png";
import openai from "@/assets/images/openai.png";

interface LogoProps {
  src: string;
  alt: string;
}

const LogoItem = ({ src, alt }: LogoProps) => (
  <div className="flex items-center justify-center h-20 w-32 group">
    <img
      src={src}
      alt={alt}
      className="h-16 w-32 object-contain transition-all duration-500 opacity-70 hover:opacity-100 hover:scale-110"
    />
  </div>
);

const logos = [
  { src: techcrunch, alt: "TechCrunch" },
  { src: google, alt: "Google" },
  { src: substack, alt: "Substack" },
  { src: nvidia, alt: "NVIDIA" },
  { src: openai, alt: "OpenAI" },
];

export default function TrustSection() {
  return (
    <section
      id="sources"
      className="w-full bg-white dot-pattern-blue py-16 sm:py-20"
      aria-labelledby="trust-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <h2
            id="trust-heading"
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-6 sm:mb-8 leading-tight"
          >
            Quality Over Quantity
          </h2>
          <p className="text-lg text-center sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Most AI news recycle the same press releases and headlines. We cut
            through the noise and source directly from the companies shipping
            the products, and the humans making it happen — researchers,
            builders, analysts, entrepreneurs, and other innovators.
          </p>
        </div>

        <div className="relative">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-5">
            <div
              className="w-full h-full"
              style={{
                backgroundImage: "radial-gradient(#000 1px, transparent 1px)",
                backgroundSize: "20px 20px",
              }}
            ></div>
          </div>

          <div className="relative z-10 flex flex-wrap items-center justify-center gap-8 sm:gap-12 py-12">
            {logos.map((logo, index) => (
              <LogoItem key={index} src={logo.src} alt={logo.alt} />
            ))}
          </div>
          <p className="text-center text-sm text-gray-400 mt-4">
            And more trusted sources
          </p>
        </div>
      </div>
    </section>
  );
}
